import React, { useEffect, useRef, useState } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useWarehouseModel } from "../../warehouseModel";
import { IVRMWarehouseDetail } from "../../warehouseTypes";
import { getFormValidatorErrText } from "@/utils/utils";
import { WarehouseDetailsTabs } from "./WarehouseDetailsTabs";
import { debounce } from "lodash";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";


export function WarehouseDatalis() {
    const {
        editFormVal,
        updateEditFormVal,
        editWarehouse,
        getWarehouseOne,
        saveLoading, setSaveLoading
    } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!editFormVal.id) {
            getWarehouseOne(detailsInfo.id)
        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav("13-3-1") && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "13-3");
    }

    //仓库修改提交
    const onSubmit = async () => {
        setSaveLoading(true)
        formRef.current?.validateFields().then(res => {
            editWarehouse({ ...res, id: detailsInfo.id as string } as IVRMWarehouseDetail).then(res => {
                res && onClose()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时缓存
    const onChange = (changedValues: any) => {
        updateEditFormVal(changedValues);
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SAVE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                loading={saveLoading}
                onClick={debounce(() => { onSubmit() }, 900)}
            >{saveLoading ? '保存中' : '保存'}</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => { message.success("重置成功") }}
        >重置</Button>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "13-3")}
        >取消</Button>
    </>;

    const baseFormItem: IYhFormItemsBox = {
        title: "仓库详情",
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        action: action,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库编码",
                fieldName: "code",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入仓库名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属站点",
                fieldName: "shopName",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "负责人",
                fieldName: "contact"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话",
                fieldName: "phone"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "地址",
                fieldName: "address"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note"
            }
        ]
    };

    const otherFormItem: IYhFormItemsBox = {
        title: "其它信息",
        // disabled: true,
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true,
            }
        ]
    }
    const warehouseFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: editFormVal,
        onChange,
        boxs: [baseFormItem, otherFormItem]
    }

    return (
        <>
            {/* <YhPageHeader title="仓库管理" /> */}
            <YhFormBox {...warehouseFromConfig} />
            {editFormVal.id ? <WarehouseDetailsTabs /> : null}
        </>
    )
}